import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { DateAdapter } from "../DateAdapter";
import { CurrencyPairCalendarLookupService } from "../../index";
import { MappedCurrencyPairCalendarImpl } from "../../model/mapped/MappedCurrencyPairCalendarImpl";

const SORT_ADJUST_ODD = 1;
const SORT_ADJUST_FIXING_DATE = 2; //?
const SORT_ADJUST_TENOR_FIXING = 3;
const DATE_FORMAT_STRING = "DD-MMM-YY";
const TIME_FORMAT_STRING = "HH:mm";

// String types that are sortable as an Int32 in C++ module
export class NdfFixingDateAdapter extends DateAdapter {
  constructor(protected currencyPairCalendarLookupService: CurrencyPairCalendarLookupService) {
    super();
    this.localeString = "DD-MMM-YY";
  }

  protected createDateString(
    timeString: string,
    timeZoneString: string,
    dateString: string,
  ): string {
    let timeValueString = CubiqTS.moment(timeString, TIME_FORMAT_STRING).format(TIME_FORMAT_STRING);
    let dateValueString = CubiqTS.moment(dateString).format(DATE_FORMAT_STRING);
    return timeValueString + " " + timeZoneString + " " + dateValueString;
  }

  getValue(order: CubiqTS.OrderDataImpl, columnProperty: string): string {
    let tenor: any = order.settleTenor;
    let data;

    if (tenor && CubiqTS.Product.NDF === order.product) {
      let ccyPairKey = `${order.baseCode}${order.nonBaseCode}`;

      let calendar: MappedCurrencyPairCalendarImpl = this.currencyPairCalendarLookupService.getItem(
        ccyPairKey,
      ) as MappedCurrencyPairCalendarImpl;

      if (calendar.tenorToValueAndFixingDateMap.has(tenor)) {
        let valueDateAndFixing = calendar.tenorToValueAndFixingDateMap.get(tenor);
        data = `(${super.retrieveData(valueDateAndFixing, "fixingDate")})`;
      }
    }

    if (CubiqTS.OrderType.BENCHMARK === order.orderType) {
      data = this.createDateString(
        order.fixingDetails.reqFixingTime,
        order.fixingDetails.reqFixingTzCd,
        order.fixingDetails.reqFixingDate,
      );
    }

    if (data == null) data = super.retrieveData(order, columnProperty);

    return data;
  }

  retrieveData(order: CubiqTS.OrderDataImpl, columnProperty: string): string {
    let data = this.getValue(order, columnProperty);

    if (order.isOddFixingDateFg === true) {
      return `${data}<span class="fa fa-fw icon-error pull-right blotter_inline_fa"></span>`;
    } else {
      return `${data}`;
    }
  }

  retrieveSort(order: CubiqTS.OrderDataImpl, columnProperty: string): number {
    let tenor: any = order.settleTenor;
    let tenorOrder: boolean = false;

    if (tenor && CubiqTS.Product.NDF === order.product) {
      let ccyPairKey = `${order.baseCode}${order.nonBaseCode}`;
      let calendar = this.currencyPairCalendarLookupService.getItem(
        ccyPairKey,
      ) as MappedCurrencyPairCalendarImpl;
      let fixingDate: CubiqTS.StandardDateImpl = null;
      let fixingDateSortable: number;

      if (calendar != null && calendar.tenorToValueAndFixingDateMap.has(tenor)) {
        let valueDateAndFixing = calendar.tenorToValueAndFixingDateMap.get(tenor);

        fixingDate = valueDateAndFixing.fixingDate;

        if (fixingDate)
          fixingDateSortable =
            CubiqTS.moment([fixingDate.year, fixingDate.month - 1, fixingDate.day]).valueOf() +
            SORT_ADJUST_TENOR_FIXING;
        else
          fixingDateSortable =
            super.retrieveSort(order, columnProperty) +
            (order.isOddFixingDateFg === true ? SORT_ADJUST_ODD : SORT_ADJUST_FIXING_DATE);

        return fixingDateSortable;
      }
    }

    return (
      super.retrieveSort(order, columnProperty) +
      (order.isOddFixingDateFg === true ? SORT_ADJUST_ODD : SORT_ADJUST_FIXING_DATE)
    );
  }
}
